<template>
  <div>
    <section class="notFound" style="height: unset; padding-bottom: 4rem">
      <div class="notFoundIcon">
        <i class="ri-star-line"/></div>
      <h2>
        {{ dictionary.errors.emptyFavoriteList }}
      </h2>
    </section>

    <p class="expl alert">
      {{ dictionary.messages.favoriteInstruction }}
      <router-link to="#" class="portfolioLink" @click="moveToWatchlist()"><i
          class="ri-folder-line"/>
        {{ dictionary.buttons.moveToWatchlist }}
      </router-link>
    </p>
  </div>
</template>

<script>
import eventBus from "../../services/events";

export default {
  name: "EmptyFavoriteList",
  methods: {
    moveToWatchlist() {

      this.$router.push(`/watchlist`);
      this.$router.go(1);
    },
  }
}
</script>

<style scoped lang="scss">

@import "../../assets/style/vars";

.expl {
  background: var(--dailyBriefBgColor);
  padding: $smallGap;
  margin: 5px;
  border-radius: 8px;
  color: var(--highlightColor);
  text-align: center;
  font-weight: 500;
}

.expl.alert {
  color: var(--textColor);
  font-size: 18px;
}

.portfolioLink {
  background: var(--highlightColor);
  color: var(--bgColor);
  display: block;
  width: fit-content;
  text-align: center;
  margin: 25px auto;
  padding: 5px 10px;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
}

</style>
